import { KTIcon } from "../../../../_metronic/helpers";

const ConfirmationModalHeader = ({
  isListing,
  data,
  setOpenConfirmationModal
}) => {
  return (
    <div className="modal-header">
      <h2 className="fw-bolder">Reset Stripe for {isListing ? data?.title : `${data.first_name} ${data.last_name}`}</h2>
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-users-modal-action="close"
        onClick={() => {
          setOpenConfirmationModal(false)
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
    </div>
  );
};

export { ConfirmationModalHeader };
